import {DESKTOP_SCREEN_WIDTH, SMALL_SCREEN_WIDTH, TABLET_SCREEN_WIDTH} from '@/constants';

export class MediaService {
  public static isSmall(width: number): boolean {
    return width <= SMALL_SCREEN_WIDTH;
  }

  public static isMedium(width: number): boolean {
    return width < TABLET_SCREEN_WIDTH && width > SMALL_SCREEN_WIDTH;
  }

  public static isTablet(width: number): boolean {
    return width >= TABLET_SCREEN_WIDTH && width < DESKTOP_SCREEN_WIDTH;
  }

  public static isDesktop(width: number): boolean {
    return width >= DESKTOP_SCREEN_WIDTH;
  }
}
